import axios from "axios"; // 引用axios
import { showLoadingToast } from 'vant';
import { router } from '@/router';
import { usePlatform } from "@/hooks";
import { useUserStore, useSettingsStore } from '@/store'
import i18n from '@/locales/index';
import MyToast from '@/plugins/component/MyToast';
import packageJson from '/package.json';

const instance = axios.create({
  // baseURL: config.baseUrl.dev,
  timeout: 10000,
});

let loading;
//正在请求数量
let requestCount = 0;
//显示loading
const showLoading = () => {
  if (requestCount === 0 && !loading) {
    loading = showLoadingToast({
      message: i18n.global.t('common.loading') + '...',
      forbidClick: true,
      duration: 0,
    });
  }
  requestCount++;
}

const hideLoading = () => {
  requestCount--;
  if (requestCount === 0) {
    loading.close();
    loading = '';
  }
}

//请求拦截器 
instance.interceptors.request.use((config) => {
  if(!config.noLoading) {
    showLoading();
  }
  const { version, versionCode, deviceId } = useSettingsStore();
  config.headers = {
    ...config.headers,
    'Accept-Language': localStorage.getItem('i18n') || 'en-US',
    // 'Authorization': 'Bearer ' + localStorage.getItem('CE_STEPFUN_TOKEN'),
    version: version,
    versionCode: versionCode,
    deviceId: deviceId,
    h5Version: packageJson.version,
    requestFrom: usePlatform().isStandalone ? 'PWA' : usePlatform().isApp ? 'APP_H5' : 'H5',
  };
  return config;
}, (error) => {
  // 对请求错误做些什么
  return Promise.reject(error)
});

//响应拦截器
instance.interceptors.response.use((response) => {
  if(!response.config.noLoading) {
    hideLoading();
  }
  //响应成功
  if (response.status === 204) {
    return Promise.resolve();
  } else if (!response.data.success) {
    if (response.data.code === '20002') {
      useUserStore().clearData();
      if (response.config.url != '/api/user/info') {
        MyToast({ type: 'danger', message: response.data.msg || 'Error!' });
        if (!router.currentRoute.value.name === 'game') {
          router.replace({ name: 'game' });
        } else {
          router.go(0)
        }
      }
    } else {
      if(!response.config.noToast) {
        setTimeout(() => { //延迟展示Toast信息  修复Toast信息被Loading挡住的问题
          MyToast({ type: 'danger', message: response.data.msg || 'Error!' });
        }, 100);
      } 
    }
    return Promise.reject(response);
  } else {
    if (response.data.msg && response.config.method !== 'get') {
      setTimeout(() => { //延迟展示Toast信息  修复Toast信息被Loading挡住的问题
        MyToast({ type: 'success', message: response.data.msg });
      }, 100);
      // MyToast({ type: 'success', message: response.data.msg });
    } 
  }
  return response.data;
}, (error) => {
  hideLoading();
  let message = 'Request error';
  //响应错误
  if(error.response && error.response.status){
    const status = error.response.status
    switch (status) {
      case 400:
        message = 'Request error'; //请求错误
        break;
      case 401:
        message = 'Request error'; //请求错误
        break;
      case 404:
        message = 'Request address error'; //请求地址出错
        break;
      case 408:
        message = 'Request timeout'; //请求超时
        break;
      case 500:
        message = 'Server error!'; //服务器内部错误
        break;
      case 501:
        message = 'Service Unavailable!'; //服务未实现
        break;
      case 502:
        message = 'Bad gateway!'; //网关错误
        break;
      case 503:
        message = 'Service Unavailable!'; //服务不可用
        break;
      case 504:
        message = 'Gateway timeout!'; //网关超时
        break;
      case 505:
        message = 'HTTP is not supported'; //HTTP版本不受支持
        break;
      default:
        message = 'Request error'; //请求失败
    }
  } else if (error.code === 'ECONNABORTED') {
    message = '';
  }
  message && MyToast({ type: 'danger', message });
  return Promise.reject(error);
});

export default instance;